/* eslint-disable no-invalid-this */
// Handles business/personal account logic on signup account step
import Cookies from "js-cookie";

const SignupForm = {
  init($form) {
    if (Cookies.get("ad_client")) {
      $form.find(".js-acquired-by-ad-id").val(Cookies.get("ad_client"));
    }

    let $checkboxToggle = $(".js-toggle-personal");
    SignupForm.togglePersonalBusiness($checkboxToggle);
    $checkboxToggle.on("click", function() {
      SignupForm.togglePersonalBusiness($(this));
    });
  },

  togglePersonalBusiness($checkboxToggle) {
    if ($checkboxToggle.prop("checked")) {
      $(".js-business").addClass("d-none");
      $(".js-personal").removeClass("d-none");
      $(".js-business-name-input").val("");
    } else {
      $(".js-business").removeClass("d-none");
      $(".js-personal").addClass("d-none");
    }
  }
};

export { SignupForm };
